export default "__VITE_ASSET__BhdXwgiu__"